<template>
  <div class="article-wrapper">
    <div class="article-lists-container" v-if="articles && articles.length > 0">
      <a
        class="grid__item-article"
        v-for="(article, index) in articles"
        :key="index"
        :href="theme === 'manage' ? 'javascript:void(0);' : article.content"
        :target="theme === 'manage' ? '' : '_blank'"
        :class="{
          'scroll-up-to hoverEffect': theme !== 'manage',
          mangeHover: theme === 'manage'
        }"
      >
        <div class="article__inner">
          <div class="inner__main-body">
            <div class="item__manage" v-if="theme === 'manage'">
              <div class="manage__item" @click.stop="onEdit(article.id)">
                <i class="icon icon-manage-edit"></i>
              </div>
              <div class="manage__item" @click.stop="onDelete(article.id)">
                <i class="icon icon-manage-delete"></i>
              </div>
              <div class="manage__item" @click.stop="routergo(article.content)">
                <i class="icon icon-manage-preview"></i>
              </div>
            </div>
            <div class="item__wrapper"
              @click.stop="routergo(article.content)"
            >
              <div class="item__cover">
                <el-image
                  fit="cover"
                  class="img"
                  :src="(article.title_picture_url || article.avatar) | parseImage"
                ></el-image>
              </div>
              <div class="item__info">
                <div class="info__label">{{ article.mold_name }}·{{ article.mold_en_name }}</div>
                <div class="info__title">{{ article.title }}</div>
                <div class="info__publish">{{ article.ctime | parseTime }}</div>
                <div class="info__summary">{{ article.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
    <Empty hint="没有找到相关信息" v-else></Empty>
    <Pagination
      class="component-pagination"
      :config="isShowPagination"
      v-if="isShowPagination && articles.length > 0"
    ></Pagination>
  </div>
</template>

<script>
import Empty from '@/pages/common/empty.vue';
import Pagination from '@/components/pagination.vue';

export default {
  components: {
    Pagination,
    Empty,
  },
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  methods: {
    routergo(url) {
      window.open(url);
    },
    onEdit(id) {
      this.$router.push({
        path: `/my/article/${id}`,
      });
    },
    onDelete(id) {
      this.$emit('onDelete', id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_mixin";
.component-pagination {
  margin-top: px2vw(98 - 30);
}
</style>
